/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BodyUpdUpload,
  PageUpdDocumentOut,
  ProblemDetail,
  RejectIn,
  ResolutionsIn,
  UpdDocumentDetail,
  UpdDocumentOut,
  UpdEventOut,
  UpdListDocumentsParams,
  VersionIn
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Загруженные УПД
 */
export const updListDocuments = (
    params?: UpdListDocumentsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageUpdDocumentOut>(
      {url: `/api/v1/upd-documents`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getUpdListDocumentsQueryKey = (params?: UpdListDocumentsParams,) => {
    return [
    `/api/v1/upd-documents`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUpdListDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof updListDocuments>>, TError = ErrorType<ProblemDetail>>(params?: UpdListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdListDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof updListDocuments>>> = ({ signal }) => updListDocuments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdListDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof updListDocuments>>>
export type UpdListDocumentsQueryError = ErrorType<ProblemDetail>


export function useUpdListDocuments<TData = Awaited<ReturnType<typeof updListDocuments>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  UpdListDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updListDocuments>>,
          TError,
          Awaited<ReturnType<typeof updListDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdListDocuments<TData = Awaited<ReturnType<typeof updListDocuments>>, TError = ErrorType<ProblemDetail>>(
 params?: UpdListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updListDocuments>>,
          TError,
          Awaited<ReturnType<typeof updListDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdListDocuments<TData = Awaited<ReturnType<typeof updListDocuments>>, TError = ErrorType<ProblemDetail>>(
 params?: UpdListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Загруженные УПД
 */

export function useUpdListDocuments<TData = Awaited<ReturnType<typeof updListDocuments>>, TError = ErrorType<ProblemDetail>>(
 params?: UpdListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updListDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdListDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Загрузить УПД (PDF, xlsx, xls, XML). Повтор того же файла — 200 и тот же документ
 */
export const updUpload = (
    bodyUpdUpload: BodyType<BodyUpdUpload>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, bodyUpdUpload.file)

      return apiRequest<UpdDocumentOut | UpdDocumentOut>(
      {url: `/api/v1/upd-documents`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUpdUploadMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updUpload>>, TError,{data: BodyType<BodyUpdUpload>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updUpload>>, TError,{data: BodyType<BodyUpdUpload>}, TContext> => {

const mutationKey = ['updUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updUpload>>, {data: BodyType<BodyUpdUpload>}> = (props) => {
          const {data} = props ?? {};

          return  updUpload(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdUploadMutationResult = NonNullable<Awaited<ReturnType<typeof updUpload>>>
    export type UpdUploadMutationBody = BodyType<BodyUpdUpload>
    export type UpdUploadMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Загрузить УПД (PDF, xlsx, xls, XML). Повтор того же файла — 200 и тот же документ
 */
export const useUpdUpload = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updUpload>>, TError,{data: BodyType<BodyUpdUpload>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updUpload>>,
        TError,
        {data: BodyType<BodyUpdUpload>},
        TContext
      > => {

      const mutationOptions = getUpdUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Документ с проблемами сопоставления и ссылкой на черновик отгрузки
 */
export const updGetDocument = (
    docId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdDocumentDetail>(
      {url: `/api/v1/upd-documents/${docId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getUpdGetDocumentQueryKey = (docId?: number,) => {
    return [
    `/api/v1/upd-documents/${docId}`
    ] as const;
    }

    
export const getUpdGetDocumentQueryOptions = <TData = Awaited<ReturnType<typeof updGetDocument>>, TError = ErrorType<ProblemDetail>>(docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdGetDocumentQueryKey(docId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof updGetDocument>>> = ({ signal }) => updGetDocument(docId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdGetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof updGetDocument>>>
export type UpdGetDocumentQueryError = ErrorType<ProblemDetail>


export function useUpdGetDocument<TData = Awaited<ReturnType<typeof updGetDocument>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updGetDocument>>,
          TError,
          Awaited<ReturnType<typeof updGetDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdGetDocument<TData = Awaited<ReturnType<typeof updGetDocument>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updGetDocument>>,
          TError,
          Awaited<ReturnType<typeof updGetDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdGetDocument<TData = Awaited<ReturnType<typeof updGetDocument>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Документ с проблемами сопоставления и ссылкой на черновик отгрузки
 */

export function useUpdGetDocument<TData = Awaited<ReturnType<typeof updGetDocument>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updGetDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdGetDocumentQueryOptions(docId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Журнал обработки документа
 */
export const updEvents = (
    docId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdEventOut[]>(
      {url: `/api/v1/upd-documents/${docId}/events`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getUpdEventsQueryKey = (docId?: number,) => {
    return [
    `/api/v1/upd-documents/${docId}/events`
    ] as const;
    }

    
export const getUpdEventsQueryOptions = <TData = Awaited<ReturnType<typeof updEvents>>, TError = ErrorType<ProblemDetail>>(docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdEventsQueryKey(docId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof updEvents>>> = ({ signal }) => updEvents(docId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdEventsQueryResult = NonNullable<Awaited<ReturnType<typeof updEvents>>>
export type UpdEventsQueryError = ErrorType<ProblemDetail>


export function useUpdEvents<TData = Awaited<ReturnType<typeof updEvents>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updEvents>>,
          TError,
          Awaited<ReturnType<typeof updEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdEvents<TData = Awaited<ReturnType<typeof updEvents>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updEvents>>,
          TError,
          Awaited<ReturnType<typeof updEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdEvents<TData = Awaited<ReturnType<typeof updEvents>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Журнал обработки документа
 */

export function useUpdEvents<TData = Awaited<ReturnType<typeof updEvents>>, TError = ErrorType<ProblemDetail>>(
 docId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updEvents>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdEventsQueryOptions(docId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Отклонить документ с причиной
 */
export const updReject = (
    docId: number,
    rejectIn: BodyType<RejectIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdDocumentDetail>(
      {url: `/api/v1/upd-documents/${docId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUpdRejectMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updReject>>, TError,{docId: number;data: BodyType<RejectIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updReject>>, TError,{docId: number;data: BodyType<RejectIn>}, TContext> => {

const mutationKey = ['updReject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updReject>>, {docId: number;data: BodyType<RejectIn>}> = (props) => {
          const {docId,data} = props ?? {};

          return  updReject(docId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdRejectMutationResult = NonNullable<Awaited<ReturnType<typeof updReject>>>
    export type UpdRejectMutationBody = BodyType<RejectIn>
    export type UpdRejectMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Отклонить документ с причиной
 */
export const useUpdReject = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updReject>>, TError,{docId: number;data: BodyType<RejectIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updReject>>,
        TError,
        {docId: number;data: BodyType<RejectIn>},
        TContext
      > => {

      const mutationOptions = getUpdRejectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Повторно разобрать документ после ошибки
 */
export const updReparse = (
    docId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdDocumentOut>(
      {url: `/api/v1/upd-documents/${docId}/reparse`, method: 'POST', ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUpdReparseMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updReparse>>, TError,{docId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updReparse>>, TError,{docId: number}, TContext> => {

const mutationKey = ['updReparse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updReparse>>, {docId: number}> = (props) => {
          const {docId} = props ?? {};

          return  updReparse(docId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdReparseMutationResult = NonNullable<Awaited<ReturnType<typeof updReparse>>>
    
    export type UpdReparseMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Повторно разобрать документ после ошибки
 */
export const useUpdReparse = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updReparse>>, TError,{docId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updReparse>>,
        TError,
        {docId: number},
        TContext
      > => {

      const mutationOptions = getUpdReparseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Решения по проблемам УПД; без проблем — создаётся черновик отгрузки
 */
export const updResolutions = (
    docId: number,
    resolutionsIn: BodyType<ResolutionsIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdDocumentDetail>(
      {url: `/api/v1/upd-documents/${docId}/resolutions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resolutionsIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUpdResolutionsMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updResolutions>>, TError,{docId: number;data: BodyType<ResolutionsIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updResolutions>>, TError,{docId: number;data: BodyType<ResolutionsIn>}, TContext> => {

const mutationKey = ['updResolutions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updResolutions>>, {docId: number;data: BodyType<ResolutionsIn>}> = (props) => {
          const {docId,data} = props ?? {};

          return  updResolutions(docId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdResolutionsMutationResult = NonNullable<Awaited<ReturnType<typeof updResolutions>>>
    export type UpdResolutionsMutationBody = BodyType<ResolutionsIn>
    export type UpdResolutionsMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Решения по проблемам УПД; без проблем — создаётся черновик отгрузки
 */
export const useUpdResolutions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updResolutions>>, TError,{docId: number;data: BodyType<ResolutionsIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updResolutions>>,
        TError,
        {docId: number;data: BodyType<ResolutionsIn>},
        TContext
      > => {

      const mutationOptions = getUpdResolutionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Сопоставить заново по текущим справочникам (без проблем — черновик отгрузки)
 */
export const updResolveAgain = (
    docId: number,
    versionIn: BodyType<VersionIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UpdDocumentDetail>(
      {url: `/api/v1/upd-documents/${docId}/resolve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: versionIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getUpdResolveAgainMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updResolveAgain>>, TError,{docId: number;data: BodyType<VersionIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updResolveAgain>>, TError,{docId: number;data: BodyType<VersionIn>}, TContext> => {

const mutationKey = ['updResolveAgain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updResolveAgain>>, {docId: number;data: BodyType<VersionIn>}> = (props) => {
          const {docId,data} = props ?? {};

          return  updResolveAgain(docId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdResolveAgainMutationResult = NonNullable<Awaited<ReturnType<typeof updResolveAgain>>>
    export type UpdResolveAgainMutationBody = BodyType<VersionIn>
    export type UpdResolveAgainMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Сопоставить заново по текущим справочникам (без проблем — черновик отгрузки)
 */
export const useUpdResolveAgain = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updResolveAgain>>, TError,{docId: number;data: BodyType<VersionIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updResolveAgain>>,
        TError,
        {docId: number;data: BodyType<VersionIn>},
        TContext
      > => {

      const mutationOptions = getUpdResolveAgainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    